<ng-container *ngrxLet="filteredUserOrganizations$;let filteredUserOrganizations">
  <div *ngIf="userOrganizations?.length>8" class="mt-8">
    <ui-search [placeholder]="'SIDEBAR.SEARCH_ORGANIZATION_PLACEHOLDER'|translate"
               #uiSearchComponent
               [heightPx]="40"
               (onInput)="onSearchOrganizationInput($event)"
    ></ui-search>
  </div>
  <div class="flex-col h-100 organization-list-wrapper">
    <div class="flex-row start-center organization-item list gap-8"
         *ngFor="let organization of filteredUserOrganizations"
         (click)="switchOrg(organization.id)"

    >
      <ui-avatar class="org-avatar selectable"
                 [name]="organization.name"
                 [color]="organization.color"
                 [fontSize]="10"
      ></ui-avatar>
      <ui-truncated-html class="truncated-name">
        {{ organization.name }}
      </ui-truncated-html>
    </div>
  </div>
</ng-container>
